import { Component, OnInit } from '@angular/core';
//import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-password-reset-result',
  templateUrl: './password-reset-result.component.html',
  styleUrls: ['./password-reset-result.component.css']
})
export class PasswordResetResultComponent implements OnInit {

  Message: string;

  constructor( ) { }

    ngOnInit() {
        this.Message = "If the email address is registered, a recovery link will have been emailed to you."
      //this.activatedRoute.queryParams.subscribe(params => {
    //  let success = params['success'];
    //  if (success == 'true') {
    //    this.Message = "An email has been sent, with the new password."
    //  }
    //  else {
    //    this.Message = "There was a problem sending the email. Please inform helpdesk@tdlpathology.com"
    //  }
    //});
  }
}
